import $ from 'jquery'
import Flickity from 'flickity'

export default () => {
    assortmentCarousel()
    lemonCelloCarousel()
    exclusiveCarousel()
    newsCarousel()
    galleryCarousel()
    relatedPostsCarousel()
    wineHouseCarousel()
    exclusiveDetailCarousel()

    function setSliderHeightToMax (slider) {
        if (!slider.cells) {
            return;
        }

        slider.cells.forEach(cell => cell.element.style.height = '');

        let heights = slider.cells.map(cell => cell.element.offsetHeight),
            max = Math.max.apply(Math, heights)

        slider.cells.forEach(cell => cell.element.style.height = max + 'px')
    }

    function createSlideshow (selector, options) {
        if (!selector) {
            return
        }

        let flkty = new Flickity(selector, options, {
            on: {
                ready: function () {
                    setSliderHeightToMax(this)
                },
            },
        })

        window.addEventListener('load', function (event) {
            flkty.resize()
            setSliderHeightToMax(flkty)
        })

        window.addEventListener('resize', function (event) {
            flkty.resize()
            setSliderHeightToMax(flkty)
        })

        $(window).on('imageLoaded', function () {
            flkty.resize()
            setSliderHeightToMax(flkty)
        })

    }

    function assortmentCarousel () {
        let assortmentSelector = document.querySelector(
            'body .assortment-home .carousel')
        let assortmentOptions = {
            cellSelector: '.item',
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: true,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(assortmentSelector, assortmentOptions)
    }

    function exclusiveCarousel () {
        let exclusiveSelector = document.querySelector(
            'body .exclusive-home .carousel')
        let exclusiveOptions = {
            cellSelector: '.item',
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: true,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(exclusiveSelector, exclusiveOptions)
    }

    function newsCarousel () {
        let newsSelector = document.querySelector('body .news-home .carousel')

        let newsOptions = {
            cellSelector: '.item',
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: false,
            cellAlign: 'left',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(newsSelector, newsOptions)
    }

    function galleryCarousel () {
        let gallerySelector = document.querySelector(
            'body .news-detail .carousel')
        let galleryOptions = {
            cellSelector: '.item',
            pageDots: false,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: true,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(gallerySelector, galleryOptions)
    }

    function relatedPostsCarousel () {
        let relatedPostSelector = document.querySelector(
            'body .news-detail .related-posts')
        let relatedPostOptions = {
            cellSelector: '.item',
            pageDots: false,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: true,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(relatedPostSelector, relatedPostOptions)
    }

    function wineHouseCarousel () {
        let wineHouseSelector = document.querySelector(
            'body .winehouse-carousel')

        let wineHouseOptions = {
            cellSelector: '.item',
            pageDots: false,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: false,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: true,
            imagesLoaded: true,
        }

        createSlideshow(wineHouseSelector, wineHouseOptions)
    }

    function exclusiveDetailCarousel () {
        let exclusiveDetailSelector = document.querySelector(
            'body .exclusive-detail .carousel')

        let exclusiveDetailOptions = {
            cellSelector: '.item',
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: true,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: false,
            imagesLoaded: true,
        }
        createSlideshow(exclusiveDetailSelector, exclusiveDetailOptions)
    }

    function lemonCelloCarousel () {
        let lemonCelloSelector = document.querySelector(
            'body .lemoncello-carousel')
        let lemonCelloOptions = {
            cellSelector: '.item',
            pageDots: true,
            contain: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            wrapAround: false,
            cellAlign: 'center',
            groupCells: false,
            draggable: '>1',
            watchCSS: true,
            imagesLoaded: true,
        }
        createSlideshow(lemonCelloSelector, lemonCelloOptions)
    }

}

